import { type ContentBlock as ContentBlockType } from '../../../shared/types'
import useBodyContent from './useBodyContent'
import styles from './BodyContent.module.scss'
import { ContentBlock } from '../'
import { parentMeta } from '../ContentBlock/type'
import { CopyContainerProps } from '../../common/copy/CopyContainer/CopyContainer'

interface BodyContentType {
  parentMeta?: parentMeta
  filePath?: string
  contentBlock?: ContentBlockType
  copyContainerStyles?: CopyContainerProps
}

const BodyContent = (props: BodyContentType) => {
  const { parentMeta, contentBlock, filePath, copyContainerStyles } = props

  const {} = useBodyContent()

  return (
    <>
      <ContentBlock
        parentMeta={parentMeta}
        className={styles.bodyContentRoot}
        contentBlock={contentBlock}
        filePath={filePath}
        copyContainerStyles={copyContainerStyles}
      ></ContentBlock>
    </>
  )
}

export default BodyContent
